const route = 'http://localhost';
const port = '8000'
const serverport ='https://aqueous-brook-29688.herokuapp.com/'
const serverportAuth = 'https://safe-meadow-34928.herokuapp.com/';
module.exports = {
    route,
    port,
    serverport
}